import React from 'react';
import PropTypes from 'prop-types';
import Link from './Link';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

import { heroBg } from '../media/images';

import Section, { Content } from './Section';
import LargeNumberSearch from './LargeNumberSearch';

const StyledHeroSearchSection = styled(Section)`
  background-image: url(${heroBg});
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 140px 17px;
`;

const Title = styled.h1`
  color: ${p => p.theme.colors.white};
  font-size: 1.875rem;
  font-weight: 900;
  line-height: 1.2;
  margin: 0 0 20px 0;
  text-align: center;

  ${breakpoints.medium`
    font-size: 2.5rem;
  `};

  ${breakpoints.large`
    font-size: 3.75rem;
  `};
`;

const Paragraph = styled.p`
  color: ${p => p.theme.colors.white};
  font-size: 1.125rem;
  line-height: 1.666666667;
  letter-spacing: 0.3px;
  text-align: center;
  margin-bottom: 40px;

  ${breakpoints.medium`
    font-size: 1.25rem;
    line-height: 2;
  `};

  ${breakpoints.large`
    font-size: 1.5625rem;
    line-height: 1.6;
  `};
`;

const SmallParagrap = styled.p`
  color: ${p => p.theme.colors.white};
  font-size: 0.9375rem;
  font-weight: 500;
  line-height: 1.67;
  text-align: center;
  margin: 0;
`;

const StyledLink = styled(Link)`
  color: ${p => p.theme.colors.white};

  &:hover {
    color: ${p => p.theme.colors.white};
    text-decoration: none;
  }
`;

export default function HeroSearchSection({ title, description }) {
  return (
    <StyledHeroSearchSection>
      <Content small>
        <Title>{title}</Title>

        <Paragraph>{description}</Paragraph>

        <LargeNumberSearch />

        <SmallParagrap>
          <StyledLink to="/bildeler/">Søk uten registreringsnummer</StyledLink>
        </SmallParagrap>
      </Content>
    </StyledHeroSearchSection>
  );
}

HeroSearchSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};

HeroSearchSection.defaultProps = {
  title: '',
  description: ''
};
